export default "__VITE_PUBLIC_ASSET__17cc85ad__"